import { ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EmailService } from '../../services/email-service';
import { Info } from './info';

interface DropdownItem {
  label: string;
  value: string;
}
@Component({
  selector: 'app-contact-form-compact',
  imports: [FormsModule],
  templateUrl: './contact-form-compact.html',
  styleUrl: './contact-form-compact.scss',
})

export class ContactFormCompact {
  info: Info = new Info('', '', '', '', '', '', undefined, true);
  public showErrorMsg: boolean = false;
  public showSuccessMsg: boolean = false;
  public isSendingRequest: boolean = false;
  constructor(private emailService: EmailService, private cd: ChangeDetectorRef) { }
  sectorList: DropdownItem[] = [
    {
      label: 'Seguridad pública',
      value: 'Seguridad pública'
    },
    {
      label: 'Gestión de GCP',
      value: 'Gestión de GCP'
    },
    {
      label: 'Petróleo y gas',
      value: 'Petróleo y gas'
    },
    {
      label: 'Prospección',
      value: 'Prospección'
    },
    {
      label: 'Construcción',
      value: 'Construcción',
    },
    {
      label: 'Otros',
      value: 'Otros'
    }
  ]
  provinceList: DropdownItem[] = [
    { label: "Álava", value: "Álava" },
    { label: "Albacete", value: "Albacete" },
    { label: "Alicante", value: "Alicante" },
    { label: "Almería", value: "Almería" },
    { label: "Asturias", value: "Asturias" },
    { label: "Ávila", value: "Ávila" },
    { label: "Badajoz", value: "Badajoz" },
    { label: "Barcelona", value: "Barcelona" },
    { label: "Burgos", value: "Burgos" },
    { label: "Cáceres", value: "Cáceres" },
    { label: "Cádiz", value: "Cádiz" },
    { label: "Cantabria", value: "Cantabria" },
    { label: "Castellón", value: "Castellón" },
    { label: "Ciudad Real", value: "Ciudad Real" },
    { label: "Córdoba", value: "Córdoba" },
    { label: "Cuenca", value: "Cuenca" },
    { label: "Girona", value: "Girona" },
    { label: "Granada", value: "Granada" },
    { label: "Guadalajara", value: "Guadalajara" },
    { label: "Guipúzcoa", value: "Guipúzcoa" },
    { label: "Huelva", value: "Huelva" },
    { label: "Huesca", value: "Huesca" },
    { label: "Illes Balears", value: "Illes Balears" },
    { label: "Jaén", value: "Jaén" },
    { label: "La Coruña", value: "La Coruña" },
    { label: "La Rioja", value: "La Rioja" },
    { label: "Las Palmas", value: "Las Palmas" },
    { label: "León", value: "León" },
    { label: "Lleida", value: "Lleida" },
    { label: "Lugo", value: "Lugo" },
    { label: "Madrid", value: "Madrid" },
    { label: "Málaga", value: "Málaga" },
    { label: "Murcia", value: "Murcia" },
    { label: "Navarra", value: "Navarra" },
    { label: "Ourense", value: "Ourense" },
    { label: "Palencia", value: "Palencia" },
    { label: "Pontevedra", value: "Pontevedra" },
    { label: "Salamanca", value: "Salamanca" },
    { label: "Santa Cruz de Tenerife", value: "Santa Cruz de Tenerife" },
    { label: "Segovia", value: "Segovia" },
    { label: "Sevilla", value: "Sevilla" },
    { label: "Soria", value: "Soria" },
    { label: "Tarragona", value: "Tarragona" },
    { label: "Teruel", value: "Teruel" },
    { label: "Toledo", value: "Toledo" },
    { label: "Valencia", value: "Valencia" },
    { label: "Valladolid", value: "Valladolid" },
    { label: "Vizcaya", value: "Vizcaya" },
    { label: "Zamora", value: "Zamora" },
    { label: "Zaragoza", value: "Zaragoza" }
  ]


  sendContactEmail() {
    let infoCopy = { ...this.info }
    delete infoCopy.accept
    this.isSendingRequest = true

    this.emailService.sendEmail(infoCopy).subscribe({
      next: (res) => {
        this.showSuccessMsg = true;
        this.isSendingRequest = false
        this.cd.detectChanges()
      },
      error: (err) => {
        console.error(err);
        this.showErrorMsg = true;
        this.isSendingRequest = false
        this.cd.detectChanges()
      }
    })
  }
}
